<template>
  <PrimaryButton :disabled="disabled" :height="height" :line-height="lineHeight" :min-width="minWidth" :on-click="onClick" :theme="theme">
    <slot />
  </PrimaryButton>
</template>

<script setup lang="ts">
import { PrimaryButton } from '@/wabunka-src/common/components';

interface Props {
  disabled?: boolean;
  onClick: () => void;
  height?: string;
  lineHeight?: string;
  minWidth?: string;
  theme?: 'light' | 'dark';
}

withDefaults(defineProps<Props>(), {
  disabled: false,
  height: '50px',
  lineHeight: '40px',
  minWidth: '120px',
  theme: 'light',
});
</script>
